import React from 'react';
import dayjs from 'dayjs';

export const DB_START_DATE = '2024-08-12';

export function isDateInRange(current, min = DB_START_DATE) {
  if (!current) return false;
  const minD = dayjs(min);
  const maxD = dayjs();
  return !(current < minD || current > maxD);
}

export function formatAddTime(timestring) {
  if (!timestring) return '';
  return timestring.replace('T', ' ').split('.')[0];
}

export function renderUserLink(userid) {
  if (!userid) return <span>-</span>;
  return (
    <a href={`https://gamelet.online/user/${userid}/`} target="_blank" rel="noopener noreferrer">
      {userid}
    </a>
  );
}

const helpers = { DB_START_DATE, isDateInRange, formatAddTime, renderUserLink };

export default helpers;
